module.exports = __webpack_public_path__ + "img/detail-personal-brand-alvaro-herrero.52c2f9f7.jpg";